import TransactionList from './TransactionList.vue';

export default TransactionList;
